import React from 'react';
import PropTypes from 'prop-types';

export default function If({ test, children }) {
  if (test) {
    return <>{children}</>;
  }
  return null;
}

If.propTypes = {
  test: PropTypes.bool.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]).isRequired,
};
